import { render, staticRenderFns } from "./SetFxRateCard.vue?vue&type=template&id=2fa504d4&"
import script from "./SetFxRateCard.vue?vue&type=script&lang=js&"
export * from "./SetFxRateCard.vue?vue&type=script&lang=js&"
import style0 from "./SetFxRateCard.vue?vue&type=style&index=0&id=2fa504d4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports